import React from "react";
import { Card, CartTitle } from "./style.js";
import PropTypes from "prop-types";
import Title from "../Layout/Title/index";
import Container from "../Layout/Container/index"
import Format from "../Layout/Format/index";
import ComponentImage from "../Layout/ComponentImage/index";
import Rating from "../Layout/Ratings/index";
import Empty from "../Layout/Empty/index";

export default function ProductCards({ product,text }) {
    return (
        <>
            {product.length === 0 ? (
                <Empty>Sorry products not found</Empty>
            ) : (
                <>
                    <Title>{text}</Title>
                    <Container width={"auto"} type={"repeat(auto-fit, minmax(350px, 1fr));"} justify={"center"} display={"grid"}>
                        {product.map((product) => (
                            <Card
                                to={`/product-detail/${product._id}`}
                                key={product._id}
                            >
                                <ComponentImage
                                    img={product.image}
                                    width={"auto"}
                                    height={"350"}
                                />
                                <Rating reviews={product.fav}></Rating>
                                <CartTitle>{product.title}</CartTitle>
                                <Format price={product.price} />
                            </Card>
                        ))}
                    </Container>
                </>
            )}
        </>
    );
}

ProductCards.propTypes = {
    product: PropTypes.array,
    text: PropTypes.string
};
